import React from 'react';
import { useTranslation } from "react-i18next";
import BackContainer from './components/backContainer';
import TicketHeader from './components/header';
import ResaleBreakdown from './components/resaleBreakdown';
import './resale.css';


export default function EditResale({ onSubmit = () => { }, config }) {
    const { t } = useTranslation();
    const { id: attendeeId } = config['resale-ticket-update-form'].header;
    const [state, setState] = React.useState({ 'price': config['resale-ticket-update-form'].resale_breakdown.price.value, 'is_private_resale': Boolean(config['resale-ticket-update-form'].resale_option.value) });

    const goToTicket = React.useCallback(() => {
        onSubmit(
            {
                data: {
                    action: 'previous',
                    payload: {
                        attendee_id: attendeeId
                    }
                }
            }
        )
    }
        , [onSubmit, attendeeId]);

    const handleSubmit = React.useCallback(() => {
        onSubmit({
            data: state
        })
    }, [state])

    return (
        <div className='resale-container'>
            <BackContainer title={t('widget.resale.back-title')} onClick={goToTicket} />
            <TicketHeader data={config['resale-ticket-update-form'].header} state={state} />
            <ResaleBreakdown data={config['resale-ticket-update-form']} state={state} setState={setState} mode='edit' onSubmit={onSubmit} handleSubmit={handleSubmit} />
        </div>
    )
}